import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, useParams } from 'react-router-dom'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'

import { verifyInvitation, doConfirmCredentials } from '../../redux/actions/domain';
import { ReactComponent as SvgLogo } from '../../assets/svg/logo.svg'
import { RiErrorWarningLine } from 'react-icons/ri'
import { BsEye,BsEyeSlash } from 'react-icons/bs'

import LoaderComponent from '../../components/CommonComponents/LoaderComponent'
const VerifyDomainPage = () => {
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const [isVerified, setIsVerified] = useState(false)
  const [isVerifying, setIsVerifying] = useState(true)
  const [redirectToLogin, setRedirectToLogin] = useState(false)
  const { emailToVerify, hash } = useParams()
  const [firstNameValues, setFirstName] = useState({
    firstName: '',
    fNameError: ''
  })
  const [lastNameValues, setLastName] = useState({
    lastName: '',
    lNameError: ''
  })
  const [passwordValues, setPassword] = useState({
    password: '',
    showPassword: false,
    pwderror: ''
  })
  const [confirmpasswordvalues, setConfirmPassword] = useState({
    confirmpassword: '',
    showPassword: false,
    confirmPwdError: ''
  })

  useEffect(() => {
    handleAcceptInvitation(emailToVerify)
  }, [])

  const handleAcceptInvitation = (email) => {
    if (!email || email === '') {
      toast.show({
        title: 'Warning',
        description: 'Email is required!'
      })
      return
    }
    dispatch(
      verifyInvitation(hash, email)
    ).then((result) => {
      setIsVerified(true)
      setIsVerifying(false)
      setFirstName({ ...firstNameValues, 'firstName': result?.firstname || '' })
      setLastName({ ...firstNameValues, 'lastName': result?.lastname || '' })
      setEmail(result?.email || '')
    }).catch(() => {
      setIsVerified(false)
      setIsVerifying(false)
    })
  }

  if (redirectToLogin) {
    return <Redirect to='/login' />
  }

  const handleInputChange = (prop) => (event) => {
    if (prop === 'firstName') {
      if (firstNameValues.firstName) {
        firstNameValues.fNameError = ''
      }
      setFirstName({ ...firstNameValues, 'firstName': event.target.value })
    } else if (prop === 'lastName') {
      if (lastNameValues.lastName) {
        lastNameValues.lNameError = ''
      }
      setLastName({ ...lastNameValues, 'lastName': event.target.value })
    } else if (prop === 'confirmpassword') {
      if (confirmpasswordvalues.confirmpassword) {
        confirmpasswordvalues.confirmPwdError = ''
      }
      setConfirmPassword({ ...confirmpasswordvalues, [prop]: event.target.value });
    } else {
      if (passwordValues.password) {
        passwordValues.pwderror = ''
      }
      setPassword({ ...passwordValues, [prop]: event.target.value });
    }
  }

  const handleClickShowPassword = (prop) => {
    if (prop === 'confirmpassword') {
      setConfirmPassword({ ...confirmpasswordvalues, showPassword: !confirmpasswordvalues.showPassword });
    } else {
      setPassword({ ...passwordValues, showPassword: !passwordValues.showPassword });
    }
  }

  const handleConfirmCredentials = () => {
    if (!firstNameValues.firstName || firstNameValues.firstName === '') {
      firstNameValues.fNameError = 'First name should not be empty!';
    } else {
      firstNameValues.fNameError = '';
    }

    if (!lastNameValues.lastName || lastNameValues.lastName === '') {
      lastNameValues.lNameError = 'Last name should not be empty!';
    } else {
      lastNameValues.lNameError = '';
    }
    if (!passwordValues.password) {
      passwordValues.pwderror = 'Password should not be empty!'
    } else {
      passwordValues.pwderror = ''
    }
    if (!confirmpasswordvalues.confirmpassword) {
      confirmpasswordvalues.confirmPwdError = 'Confirm Password should not be empty!'
    } else {
      confirmpasswordvalues.confirmPwdError = ''
    }
    if (!confirmpasswordvalues.confirmPwdError) {
      if (confirmpasswordvalues.confirmpassword !== passwordValues.password) {
        confirmpasswordvalues.confirmPwdError = 'Confirm Password must be same as new password!'
      } else {
        confirmpasswordvalues.confirmPwdError = ''
      }
    }

    if (lastNameValues.lNameError === '' && firstNameValues.fNameError === '' && passwordValues.pwderror === '' && confirmpasswordvalues.confirmPwdError === '') {
      dispatch(
        doConfirmCredentials({
          email,
          firstname: firstNameValues?.firstName,
          lastname: lastNameValues?.lastName,
          password: passwordValues.password,
        })
      ).then(() => {
        setRedirectToLogin(true)
      }).catch(() => {
        setRedirectToLogin(false)
      })
    } else {
      setPassword({ ...passwordValues })
      setConfirmPassword({ ...confirmpasswordvalues })
    }
  }

  return (
    <div className="verify-page">
      <SvgLogo />
      <div className="title">
        <h4 className="title_heading">Welcome to Ricochet</h4>
        <span>
          <h5 className="confirm_title">Please Confirm your Credentials</h5>
        </span>
      </div>
      {isVerifying && <LoaderComponent />}

      <div className="content">
        {isVerified ? (
          <>
            <div className="item">
              <h5>Email</h5>
              <input type="text" value={email} readOnly={true} />
            </div>
            <div className="item">
              <h5>First Name</h5>
              <div className={`form-input-inner ${firstNameValues.fNameError ? '' : 'has-bottom-margin'}`}>
                <div className='form-input'>
                  <input className={`${firstNameValues.fNameError ? 'error-border' : ''}`} type="text" value={firstNameValues?.firstName} onChange={handleInputChange('firstName')} />
                </div>
                {firstNameValues.fNameError && (
                  <div className='error-container flex align-center'>
                    <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                    <p className='error mb-2'>{firstNameValues.fNameError}</p>
                  </div>
                )}
              </div>
            </div>
            <div className="item">
              <h5>Last Name</h5>
              <div className={`form-input-inner ${lastNameValues.lNameError ? '' : 'has-bottom-margin'}`}>
                <div className='form-input'>
                  <input className={`${lastNameValues.lNameError ? 'error-border' : ''}`} type="text" value={lastNameValues?.lastName} onChange={handleInputChange('lastName')} />
                </div>
                {lastNameValues.lNameError && (
                  <div className='error-container flex align-center'>
                    <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                    <p className='error mb-2'>{lastNameValues.lNameError}</p>
                  </div>
                )}
              </div>
            </div>
            <div className="item">
              <h5>Password</h5>
              <div className={`form-input-inner ${passwordValues.pwderror ? '' : 'has-bottom-margin'}`}>
                <div className='form-input flex'>
                  <input className={`${passwordValues.pwderror ? 'error-border' : ''}`} type={passwordValues.showPassword ? "text" : "password"} placeholder="Type Password" value={passwordValues.password} onChange={handleInputChange('password')} />
                  {passwordValues.showPassword ?
                    <BsEye color="#104569" size={24} onClick={() => handleClickShowPassword()} /> :
                    <BsEyeSlash color="#104569" size={24} onClick={() => handleClickShowPassword()} />
                  }
                </div>
                {passwordValues.pwderror && (
                  <div className='error-container flex align-center'>
                    <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                    <p className='error mb-2'>{passwordValues.pwderror}</p>
                  </div>
                )}
              </div>
            </div>
            <div className="item">
              <h5>Confirm Password</h5>
              <div className={`form-input-inner ${confirmpasswordvalues.confirmPwdError ? '' : 'has-bottom-margin'}`}>
                <div className='form-input flex'>
                  <input className={`${confirmpasswordvalues.confirmPwdError ? 'error-border' : ''}`} type={confirmpasswordvalues.showPassword ? "text" : "password"} placeholder="Type Password" value={confirmpasswordvalues.confirmpassword} onChange={handleInputChange('confirmpassword')} />
                  {confirmpasswordvalues.showPassword ?
                    <BsEye color="#104569" size={24} onClick={() => handleClickShowPassword('confirmpassword')} /> :
                    <BsEyeSlash color="#104569" size={24} onClick={() => handleClickShowPassword('confirmpassword')} />
                  }
                </div>
              </div>
              {confirmpasswordvalues.confirmPwdError && (
                <div className='error-container flex align-center'>
                  <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                  <p className='error mb-2'>{confirmpasswordvalues.confirmPwdError}</p>
                </div>
              )}
            </div>
            <div className="action">
              <button type="button" className="btn" onClick={handleConfirmCredentials}>
                Confirm
              </button>
            </div>
          </>
        ) :
          <div>Not Verified.</div>
        }
      </div>
    </div>
  )
}
export default VerifyDomainPage